import styles from '../styles/Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <span>© 2026 Muhammad Yaseen — Karachi, Pakistan</span>
      <div className={styles.socials}>
        <a href="https://github.com/ansariyaaeen361-arch" target="_blank" rel="noreferrer" aria-label="GitHub">
          GitHub
        </a>
        <a href="https://linkedin.com/in/muhammad-yaseen-716815334" target="_blank" rel="noreferrer" aria-label="LinkedIn">
          LinkedIn
        </a>
        <a href="mailto:ansariyaaeen361@gmail.com" aria-label="Email">
          Email
        </a>
      </div>
    </footer>
  );
}
